import OssBase from 'services/request/Oss'

class Oss extends OssBase {
  fetchStatic(type, uuid) {
    return this
      .fetch(`${type}${uuid}.json`)
      .then((res) => res.data)
  }

  fetchRois(uuid) {
    return this.fetchStatic('rois', uuid)
  }

  fetchStats(uuid) {
    return this.fetchStatic('stats', uuid)
  }

  fetchFeats(uuid) {
    return this.fetchStatic('feats', uuid)
  }

  fetchFeatsTimeline(uuid) {
    return this.fetchStatic('feats-timeline', uuid)
  }

  fetchTrace(uuid) {
    return this.fetchStatic('trace', uuid)
  }
}

export default new Oss()



// WEBPACK FOOTER //
// ./src/services/api/oss.js